<header nz-row [nzGutter]="[80, 40]" class="tour-overview">
  <div nz-col nzXs="24" nzSm="24" nzMd="14" class="tour-info">
    @if ( tour.organisation | organisation : { select: ['address.country',
    'name', 'isPartner', 'logo', 'slug'] } | async; as organisation ) {
    <nz-breadcrumb [nzSeparator]="iconTemplate">
      <nz-breadcrumb-item>
        @if ( tour.address.country | country : { select: ['name', 'shortCode'] }
        | async; as country ) {
        <a
          [routerLink]="[RoutePath.toursSearch]"
          [queryParams]="{ country: country.shortCode }"
        >
          <span>{{ country?.name }}</span>
        </a>
        }
      </nz-breadcrumb-item>
      <nz-breadcrumb-item>
        <a
          [routerLink]="[RoutePath.toursSearch]"
          [queryParams]="{ city: tour.address.city }"
        >
          <span>{{ tour.address.city | unTitleCase }}</span>
        </a>
      </nz-breadcrumb-item>
      <nz-breadcrumb-item>
        <a
          [routerLink]="[
            RoutePath.organisation,
            organisation.slug || organisation._id
          ]"
        >
          <span>{{ organisation.name }}</span>
        </a>
      </nz-breadcrumb-item>
    </nz-breadcrumb>
    <ng-template #iconTemplate
      ><un-icon type="right" theme="outline"></un-icon
    ></ng-template>
    <div class="organisation-name">
      <a
        [routerLink]="[
          RoutePath.organisations,
          organisation.slug || organisation._id
        ]"
      >
        @if ( organisation.logo | fileUrl : { height: 64, width: 64, quality:
        100, format } | async; as url ) {
        <img [ngSrc]="url" height="24" width="24" />
        }</a
      >
      <h5>
        <a
          [routerLink]="[
            RoutePath.organisations,
            organisation.slug || organisation._id
          ]"
          >{{ organisation.name }}</a
        >
      </h5>
      @if (organisation.isPartner) {
      <un-icon theme="custom" type="verified" size="24"></un-icon>
      } @if (organisation.isPartner) {
      <p i18n="@@offical" class="t-medium h-sm">Offiicial</p>
      }
    </div>
    }
    <h1 class="h3 t-medium tour-name">{{ tour.name }}</h1>
    <p class="tour-short-desc">{{ tour.excerpt }}</p>
    <un-tour-header-pricing
      class="m-b-24"
      [tour]="tour"
    ></un-tour-header-pricing>
    <div class="actions">
      <un-button
        class="apply"
        size="large"
        type="primary"
        (btnClick)="bookTour()"
        i18n="@@book"
        >Book</un-button
      >
      <un-favourite-icon
        size="large"
        [ngClass]="screen.size | async"
        [type]="favType"
        [item]="tour._id"
      ></un-favourite-icon>
      <un-share unTitle="Share" i18n-unTitle></un-share>
    </div>
  </div>
  <div nz-col nzXs="24" nzSm="24" nzMd="10" class="tour-cover">
    <div class="play-overlay">
      @if ( !showVideo && (tour.coverPhoto | fileUrl : { width: 528, height:
      446, quality: 80, format: format } | async); as cover ) {
      <img
        class="cover-img"
        [ngSrc]="cover"
        width="528"
        height="446"
        [alt]="tour.name + ' - Cover'"
      />
      } @if (tour.coverVideo && showVideo) {
      <un-video-player
        [src]="tour.coverVideo"
        [autoplay]="true"
      ></un-video-player>
      } @if (tour.coverVideo && !showVideo) {
      <un-icon
        class="play-icon"
        type="play-circle"
        theme="outline"
        (click)="showVideo = true"
      ></un-icon>
      }
    </div>
  </div>
</header>

<div class="tour-stats">
  @if (auth.isLoggedIn && (auth.isAdmin || auth.isInstituteUser)) {
  <div class="inner">
    <un-card-action
      [itemId]="tour._id"
      [editLink]="[RoutePath.dashboardTours, tour._id, RoutePath.edit]"
      [cloneLink]="[RoutePath.dashboardTours, RoutePath.create]"
      [organisation]="tour.organisation"
      (delete)="delete()"
    ></un-card-action>
    <un-button [type]="tour.status" size="large">{{
      tour.status | unTitleCase
    }}</un-button>
  </div>
  }
  <div class="inner">
    <div class="stat">
      <un-icon type="eye"></un-icon>
      <span class="t-medium" i18n="@@views">Views:</span>
      <span>{{ tour.views }}</span>
    </div>
    <div class="stat">
      <un-icon type="rise"></un-icon>
      <span class="t-medium" i18n="@@impressions">Impressions:</span>
      <span>{{ tour.impressions }}</span>
    </div>
    @if ( auth.isLoggedIn && (auth.isAdmin || auth.isInstituteUser ||
    auth.isAgencyUser) ) {
    <div class="stat">
      <un-icon type="wallet"></un-icon>
      <span class="t-medium" i18n="@@commission">Commission:</span>
      @if (tour.commissionType === commType.fixed) {
      <span>{{
        tour.commissionFee
          | unCurrency : tour.currency : (fx.baseCurrency$ | async)
      }}</span>
      } @if (tour.commissionType === commType.percentage) {
      <span class="t-nowrap">{{ tour.commissionFee }} %</span>
      }
    </div>
    }
  </div>
</div>
